<template>
  <section>
    <v-card class="table-container">
      <template>
        <v-data-table :headers="headers" :items="news" :search="search" sort-by="name">
          <template v-slot:top>
            <v-toolbar flat color="white">
              <v-toolbar-title class="section-title">Novidades</v-toolbar-title>
              <v-spacer></v-spacer>

              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Procurar"
                class="mr-2 mb-4"
                single-line
                hide-details
              ></v-text-field>
              
              <v-btn 
                color="#90A99C"
                fab
                dark
                small
                class="plus-btn mb-2 mr-2"
                @click="export_excel(news)"
              >
                <v-icon>mdi mdi-download</v-icon>
              </v-btn>

              <v-dialog v-model="dialog" max-width="500px">
                <template v-slot:activator="{ on }">
                  <v-btn @click="estado='novo'" color="primary" fab dark small class="plus-btn mb-2" v-on="on">
                    <v-icon>mdi mdi-plus</v-icon>
                  </v-btn>
                </template>
                <v-card>
                  <v-card-title>
                    <span class="title-form headline">{{ formTitle }}</span>
                  </v-card-title>

                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="12">
                          <v-text-field label="Nome" :id="editedItem.id+'_name'" v-model="editedItem.name"></v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <v-textarea label="Descrição" :id="editedItem.id+'_description'" v-model="editedItem.description" required></v-textarea>
                        </v-col>
                        
                        <v-col cols="12">
                          <v-file-input 
                            v-model="video" 
                            label="Video"
                            hint="Apenas para acrescentar/substituir"
                            persistent-hint
                          ></v-file-input>
                        </v-col>
                        <v-col cols="12">
                          <v-file-input 
                            v-model="image" 
                            label="Imagem 1 (Principal)"
                            hint="Apenas para acrescentar/substituir"
                            persistent-hint
                          ></v-file-input>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <p>{{productMsg}}</p>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" class="mr-0 mb-2" x-small outlined fab @click="close">
                      <v-icon>mdi mdi-close</v-icon>
                    </v-btn>
                    <v-btn color="primary" class="mr-2 mb-2" x-small fab @click="save">
                      <v-icon>mdi mdi-content-save</v-icon>
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-toolbar>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-btn x-small depressed class="mr-2" fab dark color="#90A99C" @click="editItem(item)">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
            <v-btn x-small depressed fab dark color="#7E1416" @click="deleteItem(item)">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </template>
    </v-card>
  </section>
</template>

<script>
import {json2excel} from 'js2excel'

export default {
  name: "news",
  data: () => ({
    search: '',
    dialog: false,
    headers: [
      { text: "ID", align: "start", sortable: true, value: "id" },
      { text: "Novidade", sortable: true, value: "name" },
      { text: "Descrição", value: "description" },
      { text: "Acções", value: "actions", align: "end", sortable: false }
    ],
    news: [],
    editedIndex: -1,
    editedItem: {},
    defaultItem: {},
    estado: "",
    productMsg: "",
    createResult: {},
    updateResult: {},

    image: [],
    image_2: [],
    image_3: [],
    video: [],
    form_data: new FormData(),

    link_1: [],
    link_2: [],
    link_3: [],
    link_4: [],
    link_5: []

  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Criar Novidade" : "Editar Novidade";
    }
  },

  watch: {
    dialog(val) {
      if(val == false) {
        this.close()
        this.productMsg = ""
        this.form_data = new FormData()
        this.editedItem = {}
        this.image = []
        this.image_2 = []
        this.image_3 = []
        this.video = []
        
        this.link_1 = []
        this.link_2 = []
        this.link_3 = []
        this.link_4 = []
        this.link_5 = []
      }
    }
  },

  created() {
    this.initialize();
  },

  methods: {
    export_excel: async function(data) {
      try {
          json2excel({
              data,
              name: 'news-list',
              formateDate: 'yyyy-mm-dd'
          });
      } catch (e) {
        alert('export error');
      }
    },
    async initialize() {
      await this.$store.dispatch('collectNews', this)
    },

    editItem(item) {
      this.editedIndex = this.news.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
      this.estado = "editar";
    },

    async deleteItem(item) {
      if (!confirm("Tem a certeza que quer eliminar esta Produto?")){
        return
      }
      this.deletedItem = item

      this.deletedItem.status = 0

      await this.$store.dispatch("deleteNews", this);
      // this.initialize();
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    async save() {
      this.productMsg = "A validar...";
      
      delete this.editedItem.last_update_dt 
      delete this.editedItem.update_count

      let images = ['image', 'video']
      for(let i of images) {
        if(typeof this[i].name == 'string') {
          this.editedItem[i] = this[i]
        }
      }
      for(let i of images) {
        if(this.editedItem[i] == 'null') {
          this.editedItem[i] = ""
        }
      }

      let files = ['link_1', 'link_2', 'link_3', 'link_4', 'link_5']
      for(let i of files) {
        if(typeof this[i].name == 'string') {
          this.editedItem[i] = this[i]
        }
      }
      for(let i of files) {
        if(this.editedItem[i] == 'null') {
          this.editedItem[i] = ""
        }
      }

      if (this.editedItem.name == "") {
        this.productMsg = "Introduza o nome da Novidade";
      } 
      else if ((this.editedItem.image == "" || typeof this.editedItem.image == 'undefined') && (this.editedItem.video == "" || typeof this.editedItem.video == 'undefined') && this.editedIndex == -1) {
        this.productMsg = "Selecione pelo menos a imagem principal ou um video";
      } 
      else {

        var form_data = new FormData();

        Object.keys(this.editedItem).forEach(key => form_data.append(key, this.editedItem[key]));
        this.form_data = form_data

        if (this.editedIndex > -1) {
          await this.$store.dispatch("updateNews", this)
        } 
        else {
          await this.$store.dispatch("createNews", this)
        }
      }
    }
  }
};
</script>
